<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">Dashboard</h1>
    <p class="mb-8 leading-normal">Benvenuto!</p>

    <div class="mb-8 flex items-center gap-4">
      <p class="leading-normal font-bold uppercase">Statistica {{ selectedYear === 'all' ? 'Tutti gli anni' : selectedYear }}</p>
      <select
        v-model="currentYear"
        @change="changeYear"
        class="rounded border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
      >
        <option value="all">Tutti gli anni</option>
        <option v-for="year in availableYears" :key="year" :value="year">
          {{ year }}
        </option>
      </select>
    </div>

    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
      <div>
        <stat-card label="Totale pagato" :value="formatCurrency(total)" />
      </div>
      <div>
        <stat-card label="Ingressi venduti" :value="formatNumber(ticketsSold)" />
      </div>
      <template v-if="selectedYear !== 'all'">
        <div>
          <stat-card label="Biglietti oggi" :value="formatCurrency(today)" />
        </div>
        <div>
          <stat-card label="Biglietti questa settimana" :value="formatCurrency(thisWeek)" />
        </div>
      </template>
      <div>
        <stat-card label="Pagamenti in progress" :value="formatNumber(paymentsInProgress)" />
      </div>
    </div>
  </div>
</template>

<script>
import Layout from "@/Pages/Dashboard/Shared/DashboardLayout";
import StatCard from "@/Pages/Dashboard/Shared/StatCard.vue";
import { Head } from "@inertiajs/inertia-vue3";
import { QrcodeStream } from "vue-qrcode-reader";
import { Inertia } from "@inertiajs/inertia";

export default {
  components: {
    StatCard,
    Head,
    QrcodeStream,
  },
  layout: Layout,
  props: ["total", "ticketsSold", "today", "thisWeek", "paymentsInProgress", "selectedYear", "availableYears"],
  data() {
    return {
      currentYear: this.selectedYear,
    };
  },
  mounted() {
    // Load year from localStorage on mount, but only if not in URL
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('year')) {
      const savedYear = localStorage.getItem('dashboard_year');
      const parsedYear = savedYear === 'all' ? 'all' : parseInt(savedYear);
      if (savedYear && (parsedYear === 'all' || this.availableYears.includes(parsedYear))) {
        this.currentYear = parsedYear;
        Inertia.visit(`/dashboard?year=${this.currentYear}`, { preserveState: true });
      }
    }
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
      }).format(value || 0);
    },
    formatNumber(value) {
      return new Intl.NumberFormat("it-IT").format(value || 0);
    },
    changeYear() {
      // Save to localStorage
      localStorage.setItem('dashboard_year', this.currentYear);
      // Update URL and reload data
      Inertia.visit(`/dashboard?year=${this.currentYear}`, { preserveState: false });
    },
  },
};
</script>
